// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import success from '@/i18n/locales/pt-BR/success.json';

export const successCopy = success;
